import { IAnnotationData } from "../shared/types";
import { AnnotationActions } from "./constants";
import { getURLParams } from "./utils";
import { fetchAmbrosiaJson } from "../../../viewer-express-api/src/adapters/utils/fileUtils";

let ambrosiaId: string | undefined = window.ambrosia?.$id;
const getAmbrosiaId = async () => {
  if (ambrosiaId) return ambrosiaId;
  const packagePath = getURLParams().packagePath || process.env.VITE_PACKAGE_DIR || "";
  const ambrosia = await fetchAmbrosiaJson(packagePath);
  ambrosiaId = ambrosia["$id"];
  return ambrosiaId;
};
void getAmbrosiaId();
const StoreKey = (): string => `annotation-data-${ambrosiaId ?? window.ambrosia?.$id}`;

const getAnnotationsFromStorage = () => {
  return new Map(JSON.parse(window.localStorage.getItem(StoreKey()) as string));
};

const getAnnotations = (pageId?: string) => {
  const annotationDataMap = getAnnotationsFromStorage();
  if (pageId) {
    return (annotationDataMap.get(pageId) as Array<IAnnotationData>) || [];
  } else {
    return annotationDataMap;
  }
};

const saveAnnotation = (data: IAnnotationData) => {
  const annotationDataMap = getAnnotationsFromStorage();
  const annotationData = (annotationDataMap.get(data.pageId) as Array<IAnnotationData>) || [];

  // Require a defined id for lookup — loose equality on undefined would match
  // other records that also lack an id.
  const annotationIndex =
    data.annotationId != null && data.annotationId !== ""
      ? annotationData.findIndex(
          (annotation: IAnnotationData) => annotation.annotationId === data.annotationId,
        )
      : -1;

  if (annotationIndex !== -1) {
    if (data.actionType === AnnotationActions.Delete) {
      annotationData.splice(annotationIndex, 1);
    } else {
      annotationData[annotationIndex] = data;
    }
  } else {
    annotationData.push(data);
  }

  annotationDataMap.set(data.pageId, annotationData);

  window.localStorage.setItem(StoreKey(), JSON.stringify([...annotationDataMap]));
};

export const DataProvider = {
  getAnnotations,
  saveAnnotation,
};
